import 'lazysizes'
import 'lazysizes/plugins/rias/ls.rias'
import 'lazysizes/plugins/bgset/ls.bgset.min'
import Utils from './Utils'
import Cookies from 'js-cookie'
import Slick from './Slick'

class RecentlyViewed {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this._utils = new Utils()
    }

    onInit () {
        const _this = this

        window.addEventListener('load', function () {
            _this.initRecentlyViewed()
        })
    }

    async initRecentlyViewed () {
        let viewedProducts = Cookies.get('viewed-products')
        if (viewedProducts != null) {
            let viewedHandlesArr = viewedProducts.split('###')
            let _this = this
            let all = []
            let toShow = false
            let currentHandle = typeof jsonProduct !== 'undefined' ? window.jsonProduct['handle'] : null

            for (let i = 0; i < viewedHandlesArr.length; i++) {
                if (currentHandle !== viewedHandlesArr[i]) {
                    var p = new Promise(function (resolve, reject) {
                        var request = new XMLHttpRequest()
                        request.responseType = 'document'
                        request.open('GET', '/products/' + viewedHandlesArr[i], true)
                        request.onload = function () {
                            if (request.status === 200) {
                                let viewedBlock = request.responseXML.querySelector('.recently-viewed-block')
                                toShow = true
                                resolve(viewedBlock)
                            } else {
                                resolve(null)
                            }
                        }
                        request.onerror = function () {
                            resolve(null)
                        }
                        request.send()
                    })
                    all.push(p)
                }
            }
            Promise.all(all).then(values => {
                values.forEach(function (p) {
                    if (p) {
                        _this._elem.innerHTML = _this._elem.innerHTML + p.outerHTML
                    }
                })
                _this.initRecentlyViewedSlider(toShow)
            })
        }
    }

    initRecentlyViewedSlider (toShow) {
        if (toShow) {
            let _this = this
            let title = this._elem.getAttribute('data-title')
            let titleEl = this.createTitle(title)
            let parentContainer = this._elem.parentElement

            setTimeout(function () {
                _this._elem.dataset.slick = `{
                    "slidesToShow": 6,
                    "slidesToScroll": 6,
                    "infinite": false,
                    "variableWidth": false,
                    "arrows": true,
                    "nextArrow": "<button type='button' class='slick-next'></button>",
                    "prevArrow": "<button type='button' class='slick-prev'></button>",
                    "responsive": [
                        {
                            "breakpoint": 768,
                            "settings": {
                                "arrows": false,
                                "slidesToShow": 1.2,
                                "slidesToScroll": 1
                            }
                        },
                        {
                            "breakpoint": 1080,
                            "settings": {
                                "arrows": false,
                                "slidesToShow": 3,
                                "slidesToScroll": 3
                            }
                        }
                    ]
                }`
                let slick = new Slick(null, _this._elem)
                console.log(slick)
                if (title) {
                    parentContainer.insertBefore(titleEl, parentContainer.firstChild)
                }
            }, 50)
        }
    }

    createTitle (text) {
        let titleEl = document.createElement('div')
        titleEl.className = 'block-featured'
        titleEl.innerHTML = `<h4>${text}</h4>`
        return titleEl
    }
}

export default RecentlyViewed



// WEBPACK FOOTER //
// ./src/resources/scripts/components/RecentlyViewed.js